import { Pipe, PipeTransform } from '@angular/core';
import { TabloStructoreElement } from '@ui/tablo-generator/types';

@Pipe({
    name: 'staticTextLabel',
    standalone: false
})
export class StaticTextLabelPipe implements PipeTransform {
  transform(value: TabloStructoreElement): unknown {
    if (value.type === 'statictext' && value.config.config.text) {
      return value.config.config.text
        .replaceAll('[', '')
        .replaceAll(']', '')
        .substr(0, 20);
    } else {
      return 'Mój tekst';
    }
  }
}
